// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__Ay_ia","main_collection":"styles_main_collection__zdil2"};